// extracted by mini-css-extract-plugin
module.exports = {"SoftwarePage":"SoftwarePage_SoftwarePage__6U34E","description":"SoftwarePage_description__3p7iP","title":"SoftwarePage_title__1gcXx","card":"SoftwarePage_card__qtghf"};